function hasInvalidCharsInAssetName (keyCode) {

	return keyCode === 42 || keyCode === 95 || keyCode === 60 || keyCode === 62;

}

export default hasInvalidCharsInAssetName;
